(function () {
  "use strict";

// [module] src/runtime/modules/legacy/scripts/runtime.mjs
function registerLegacyScriptsRuntime() {
  // --- Canonical attribution persistence (first touch + last touch + click IDs) ---
  (function () {
    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const CLICK_ID_KEYS = [
      'gclid',
      'dclid',
      'gbraid',
      'wbraid',
      'msclkid',
      'fbclid',
      'ttclid',
      'twclid',
      'li_fat_id',
      'pin_clickid',
      'rdt_cid'
    ];
    const STORAGE_KEY = 'stern_attribution_v2';
    const COOKIE_KEY = 'stern_attribution_v2';
    const COOKIE_DOMAIN = '.sternpinball.com';
    const MAX_COOKIE_AGE_SECONDS = 90 * 24 * 60 * 60;
    const FIRST_TOUCH_TTL_MS = 90 * 24 * 60 * 60 * 1000;
    const LAST_TOUCH_TTL_MS = 30 * 24 * 60 * 60 * 1000;
    const SESSION_TTL_MS = 30 * 60 * 1000;
    const EMPTY_TOUCH = {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: '',
      gclid: '',
      dclid: '',
      gbraid: '',
      wbraid: '',
      msclkid: '',
      fbclid: '',
      ttclid: '',
      twclid: '',
      li_fat_id: '',
      pin_clickid: '',
      rdt_cid: '',
      referrer_hostname: '',
      landing_page: '',
      landing_ts: 0
    };
    const INTERNAL_HOSTS = [
      'sternpinball.com',
      'shop.sternpinball.com',
      'staging-sternpinball.kinsta.cloud'
    ];
  
    function sanitizeString(value, maxLen) {
      const maxLength = typeof maxLen === 'number' ? maxLen : 256;
      if (value == null) return '';
      return String(value).trim().slice(0, maxLength);
    }
  
    function sanitizeTimestamp(value) {
      const numeric = Number(value);
      return Number.isFinite(numeric) && numeric > 0 ? Math.floor(numeric) : 0;
    }
  
    function hasAnyValue(values) {
      if (!values || typeof values !== 'object') return false;
      return Object.keys(values).some((key) => sanitizeString(values[key]).length > 0);
    }
  
    function getReferrerHostname() {
      if (!document.referrer) return '';
      try {
        return sanitizeString(new URL(document.referrer).hostname.toLowerCase(), 128);
      } catch (e) {
        return '';
      }
    }
  
    function isInternalHost(hostname) {
      const host = sanitizeString(hostname, 128).toLowerCase();
      if (!host) return false;
      return INTERNAL_HOSTS.some((entry) => host === entry || host.endsWith('.' + entry));
    }
  
    function getLandingPage() {
      const path = sanitizeString(window.location.pathname || '/', 512) || '/';
      const search = sanitizeString(window.location.search || '', 512);
      return sanitizeString(path + search, 768);
    }
  
    function readQueryParams(keys) {
      const urlParams = new URLSearchParams(window.location.search);
      const values = {};
      keys.forEach((key) => {
        const value = sanitizeString(urlParams.get(key));
        if (value) values[key] = value;
      });
      return values;
    }
  
    function readCookieByName(name) {
      try {
        const pattern = '(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)';
        const match = document.cookie.match(new RegExp(pattern));
        return match ? decodeURIComponent(match[1]) : '';
      } catch (e) {
        return '';
      }
    }
  
    function writeCookie(name, value) {
      try {
        const encodedValue = encodeURIComponent(value);
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = [
          name + '=' + encodedValue,
          'path=/',
          'max-age=' + MAX_COOKIE_AGE_SECONDS,
          'domain=' + COOKIE_DOMAIN,
          'SameSite=Lax' + secure
        ].join('; ');
      } catch (e) {}
    }

    function clearCookie(name) {
      try {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = [
          name + '=',
          'path=/',
          'max-age=0',
          'domain=' + COOKIE_DOMAIN,
          'SameSite=Lax' + secure
        ].join('; ');
      } catch (e) {}
    }

    function clearPersistentAttribution() {
      try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem('stern_utm_v1');
      } catch (e) {}
      clearCookie(COOKIE_KEY);
    }
  
    function readClickIdsFromUrlOrCookie() {
      const clickIds = readQueryParams(CLICK_ID_KEYS);
      if (!clickIds.rdt_cid) {
        const rdtCid = sanitizeString(readCookieByName('rdt_cid'));
        if (rdtCid) clickIds.rdt_cid = rdtCid;
      }
      return clickIds;
    }
  
    function shouldPersistAttribution() {
      return hasAnalyticsConsent();
    }
  
    function hasAnalyticsConsent() {
      try {
        if (window.CookieYes && window.CookieYes.consent) {
          const value = window.CookieYes.consent.analytics;
          return value === true || value === 'yes' || value === 'granted';
        }
      } catch (e) {}
      try {
        if (window.cookieyes && window.cookieyes.consent) {
          const value = window.cookieyes.consent.analytics;
          return value === true || value === 'yes' || value === 'granted';
        }
      } catch (e) {}
      try {
        const rawConsent = readCookieByName('cookieyes-consent');
        if (!rawConsent) return false;
        const consent = {};
        rawConsent.split(',').forEach((pair) => {
          const separator = pair.indexOf(':');
          if (separator === -1) return;
          const key = pair.substring(0, separator).trim();
          const value = pair.substring(separator + 1).trim();
          if (key) consent[key] = value;
        });
        return consent.action === 'yes' && consent.analytics === 'yes';
      } catch (e) {}
      return false;
    }
  
    function createVisitorId() {
      const seed = Math.random().toString(36).slice(2, 10);
      return 'sid_' + Date.now().toString(36) + '_' + seed;
    }
  
    function sanitizeTouch(rawTouch) {
      const touch = Object.assign({}, EMPTY_TOUCH);
      const incoming = rawTouch || {};
      Object.keys(touch).forEach((key) => {
        if (key === 'landing_ts') {
          touch[key] = sanitizeTimestamp(incoming[key]);
        } else {
          const maxLen = key === 'landing_page' ? 768 : 256;
          touch[key] = sanitizeString(incoming[key], maxLen);
        }
      });
      return touch;
    }
  
    function normalizeCanonical(rawCanonical) {
      const now = Date.now();
      const canonical = rawCanonical && typeof rawCanonical === 'object' ? rawCanonical : {};
  
      const normalized = {
        schema_version: 2,
        storage_mode: shouldPersistAttribution() ? 'persistent' : 'memory_only',
        created_at: sanitizeTimestamp(canonical.created_at) || now,
        updated_at: sanitizeTimestamp(canonical.updated_at) || now,
        first_touch_at: sanitizeTimestamp(canonical.first_touch_at),
        last_touch_at: sanitizeTimestamp(canonical.last_touch_at),
        session_start_at: sanitizeTimestamp(canonical.session_start_at),
        session_last_at: sanitizeTimestamp(canonical.session_last_at),
        first_touch: sanitizeTouch(canonical.first_touch),
        last_touch: sanitizeTouch(canonical.last_touch),
        visitor_id: sanitizeString(canonical.visitor_id, 80),
        source_origin: sanitizeString(canonical.source_origin, 32)
      };
  
      if (normalized.first_touch_at && now - normalized.first_touch_at > FIRST_TOUCH_TTL_MS) {
        normalized.first_touch_at = 0;
        normalized.first_touch = sanitizeTouch(null);
      }
  
      if (normalized.last_touch_at && now - normalized.last_touch_at > LAST_TOUCH_TTL_MS) {
        normalized.last_touch_at = 0;
        normalized.last_touch = sanitizeTouch(null);
      }
  
      if (!normalized.session_last_at || now - normalized.session_last_at > SESSION_TTL_MS) {
        normalized.session_start_at = now;
      }
      normalized.session_last_at = now;
      normalized.updated_at = now;
  
      if (!normalized.visitor_id && hasAnalyticsConsent()) {
        normalized.visitor_id = createVisitorId();
      }
  
      return normalized;
    }
  
    function touchSignature(touch) {
      const safeTouch = sanitizeTouch(touch);
      const keys = UTM_KEYS.concat(CLICK_ID_KEYS);
      return keys.map((key) => safeTouch[key] || '').join('|');
    }
  
    function shouldUpdateLastTouch(previousTouch, incomingTouch) {
      const previousSignature = touchSignature(previousTouch);
      const incomingSignature = touchSignature(incomingTouch);
      if (!incomingSignature.replace(/\|/g, '')) return false;
      return previousSignature !== incomingSignature;
    }
  
    function buildIncomingTouch(now) {
      const utmValues = readQueryParams(UTM_KEYS);
      const clickIds = readClickIdsFromUrlOrCookie();
      const referrerHostname = getReferrerHostname();
  
      const touch = sanitizeTouch(Object.assign({}, utmValues, clickIds, {
        referrer_hostname: referrerHostname,
        landing_page: getLandingPage(),
        landing_ts: now
      }));
  
      const hasCampaignSignal = hasAnyValue(utmValues) || hasAnyValue(clickIds);
      if (hasCampaignSignal) {
        return { touch, isQualifying: true, sourceOrigin: 'shopify' };
      }

      if (referrerHostname && !isInternalHost(referrerHostname)) {
        // External referrer without UTM params: keep referrer_hostname (already in touch)
        // but do NOT synthesize utm_source/medium/campaign. Blank is preferred over fake values.
        return { touch, isQualifying: true, sourceOrigin: 'shopify' };
      }

      return { touch, isQualifying: false, sourceOrigin: 'shopify' };
    }
  
    function readLegacyAttributionFallback() {
      try {
        const raw = localStorage.getItem('stern_utm_v1');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.utm || !parsed.ts) return null;
        const ts = sanitizeTimestamp(parsed.ts);
        if (!ts) return null;
        const touch = sanitizeTouch(Object.assign({}, parsed.utm, { landing_ts: ts }));
        if (isLegacyWpFallbackTouch(touch)) {
          try {
            localStorage.removeItem('stern_utm_v1');
          } catch (e) {}
          return null;
        }
        return {
          schema_version: 2,
          created_at: ts,
          updated_at: Date.now(),
          first_touch_at: ts,
          last_touch_at: ts,
          first_touch: touch,
          last_touch: touch
        };
      } catch (e) {
        return null;
      }
    }

    function isSyntheticReferralTouch(rawTouch) {
      const touch = sanitizeTouch(rawTouch);
      const medium = sanitizeString(touch.utm_medium, 80).toLowerCase();
      const campaign = sanitizeString(touch.utm_campaign, 120).toLowerCase();
      if (medium !== 'referral' || campaign !== 'referral') return false;
      if (sanitizeString(touch.utm_term) || sanitizeString(touch.utm_content)) return false;
      if (CLICK_ID_KEYS.some((key) => sanitizeString(touch[key]))) return false;
      return true;
    }

    function cleanSyntheticReferralTouch(rawTouch) {
      const touch = sanitizeTouch(rawTouch);
      touch.utm_source = '';
      touch.utm_medium = '';
      touch.utm_campaign = '';
      return touch;
    }

    function cleanupSyntheticReferralCanonical(rawCanonical) {
      if (!rawCanonical || typeof rawCanonical !== 'object') {
        return { canonical: rawCanonical, didClean: false };
      }
      const canonical = Object.assign({}, rawCanonical);
      let didClean = false;
      if (isSyntheticReferralTouch(canonical.first_touch)) {
        canonical.first_touch = cleanSyntheticReferralTouch(canonical.first_touch);
        didClean = true;
      }
      if (isSyntheticReferralTouch(canonical.last_touch)) {
        canonical.last_touch = cleanSyntheticReferralTouch(canonical.last_touch);
        didClean = true;
      }
      return { canonical, didClean };
    }

    function isLegacyWpFallbackTouch(rawTouch) {
      const touch = sanitizeTouch(rawTouch);
      const source = sanitizeString(touch.utm_source, 80).toLowerCase();
      const medium = sanitizeString(touch.utm_medium, 80).toLowerCase();
      const campaign = sanitizeString(touch.utm_campaign, 120).toLowerCase();
      if (source !== 'wp' || medium !== 'referral' || campaign !== 'wp_to_shop') return false;
      if (sanitizeString(touch.utm_term) || sanitizeString(touch.utm_content)) return false;
      if (CLICK_ID_KEYS.some((key) => sanitizeString(touch[key]))) return false;
      const refHost = sanitizeString(touch.referrer_hostname, 128).toLowerCase();
      if (refHost && !isInternalHost(refHost)) return false;
      return true;
    }

    function cleanupLegacyWpFallbackCanonical(rawCanonical) {
      if (!rawCanonical || typeof rawCanonical !== 'object') {
        return { canonical: rawCanonical, didClean: false };
      }

      const canonical = Object.assign({}, rawCanonical);
      const firstTouch = sanitizeTouch(canonical.first_touch);
      const lastTouch = sanitizeTouch(canonical.last_touch);
      const firstFallback = isLegacyWpFallbackTouch(firstTouch);
      const lastFallback = isLegacyWpFallbackTouch(lastTouch);

      if (!firstFallback && !lastFallback) {
        return { canonical: rawCanonical, didClean: false };
      }

      let nextFirst = firstFallback ? null : firstTouch;
      let nextLast = lastFallback ? null : lastTouch;

      if (!nextFirst && nextLast && hasAnyValue(nextLast)) {
        nextFirst = sanitizeTouch(nextLast);
      }
      if (!nextLast && nextFirst && hasAnyValue(nextFirst)) {
        nextLast = sanitizeTouch(nextFirst);
      }

      if (!nextFirst && !nextLast) {
        return { canonical: null, didClean: true };
      }

      canonical.first_touch = nextFirst || sanitizeTouch(null);
      canonical.last_touch = nextLast || sanitizeTouch(null);
      canonical.first_touch_at = nextFirst
        ? (sanitizeTimestamp(canonical.first_touch_at) || sanitizeTimestamp(canonical.last_touch_at) || Date.now())
        : 0;
      canonical.last_touch_at = nextLast
        ? (sanitizeTimestamp(canonical.last_touch_at) || sanitizeTimestamp(canonical.first_touch_at) || Date.now())
        : 0;

      return { canonical, didClean: true };
    }
  
    function loadCanonicalAttribution() {
      if (!shouldPersistAttribution()) {
        clearPersistentAttribution();
        return normalizeCanonical(null);
      }
      let parsed = null;
      try {
        const rawLocal = localStorage.getItem(STORAGE_KEY);
        if (rawLocal) parsed = JSON.parse(rawLocal);
      } catch (e) {}
      if (!parsed) {
        try {
          const rawCookie = readCookieByName(COOKIE_KEY);
          if (rawCookie) parsed = JSON.parse(rawCookie);
        } catch (e) {}
      }
      if (!parsed) {
        parsed = readLegacyAttributionFallback();
      }

      const cleanupResult = cleanupLegacyWpFallbackCanonical(parsed);
      if (cleanupResult.didClean && !cleanupResult.canonical) {
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
        clearCookie(COOKIE_KEY);
      }
      parsed = cleanupResult.canonical;

      const referralCleanup = cleanupSyntheticReferralCanonical(parsed);
      if (referralCleanup.didClean) {
        parsed = referralCleanup.canonical;
        if (parsed) {
          try {
            const payload = JSON.stringify(parsed);
            localStorage.setItem(STORAGE_KEY, payload);
            writeCookie(COOKIE_KEY, payload);
          } catch (e) {}
        }
      }

      return normalizeCanonical(parsed);
    }
  
    function persistCanonicalAttribution(canonical) {
      if (!shouldPersistAttribution()) {
        clearPersistentAttribution();
        return;
      }
      try {
        const payload = JSON.stringify(canonical);
        localStorage.setItem(STORAGE_KEY, payload);
        writeCookie(COOKIE_KEY, payload);
      } catch (e) {}
    }
  
    function getLastTouch(canonical) {
      const current = canonical || window.__sternAttribution || {};
      const lastTouch = sanitizeTouch(current.last_touch);
      if (hasAnyValue(lastTouch)) return lastTouch;
      return sanitizeTouch(current.first_touch);
    }
  
    function getFirstTouch(canonical) {
      const current = canonical || window.__sternAttribution || {};
      return sanitizeTouch(current.first_touch);
    }
  
    function getMergedUtm(canonical) {
      const lastTouch = getLastTouch(canonical);
      const urlUtm = readQueryParams(UTM_KEYS);
      const merged = {};
      UTM_KEYS.forEach((key) => {
        const value = sanitizeString(urlUtm[key] || lastTouch[key]);
        if (value) merged[key] = value;
      });
      return merged;
    }
  
    function getClickIds(canonical) {
      const lastTouch = getLastTouch(canonical);
      const urlClickIds = readClickIdsFromUrlOrCookie();
      const merged = {};
      CLICK_ID_KEYS.forEach((key) => {
        const value = sanitizeString(urlClickIds[key] || lastTouch[key]);
        if (value) merged[key] = value;
      });
      return merged;
    }
  
    function getDealSource(utmMerged, canonical) {
      const can = canonical || getCanonicalAttribution();
      const origin = sanitizeString(can.source_origin, 40).toLowerCase();
      if (origin === 'wp') return 'WP';
      return 'Shopify';
    }
  
    function getQueryDecoratorParams(canonical) {
      const queryParams = Object.assign({}, getMergedUtm(canonical), getClickIds(canonical));
      Object.keys(queryParams).forEach((key) => {
        if (!sanitizeString(queryParams[key])) {
          delete queryParams[key];
        }
      });
      return queryParams;
    }

    function isCrossDomainTarget(urlObj) {
      if (!urlObj || !urlObj.hostname) return false;
      const destinationHost = sanitizeString(urlObj.hostname, 128).toLowerCase();
      const currentHost = sanitizeString(window.location.hostname, 128).toLowerCase();

      if (!destinationHost || destinationHost === currentHost) return false;
      if (destinationHost === 'staging-sternpinball.kinsta.cloud') return true;
      if (destinationHost === 'sternpinball.com') return true;
      return destinationHost.endsWith('.sternpinball.com');
    }

    function decorateCrossDomainLink(anchorEl) {
      try {
        if (!hasAnalyticsConsent()) return;
        if (!anchorEl || typeof anchorEl.getAttribute !== 'function') return;
        const href = anchorEl.getAttribute('href');
        if (!href) return;
        if (href.charAt(0) === '#') return;
        if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) {
          return;
        }

        const targetUrl = new URL(href, window.location.origin);
        if (!isCrossDomainTarget(targetUrl)) return;

        const params = getQueryDecoratorParams(window.__sternAttribution);
        Object.keys(params).forEach((key) => {
          if (!targetUrl.searchParams.get(key)) {
            targetUrl.searchParams.set(key, params[key]);
          }
        });

        anchorEl.setAttribute('href', targetUrl.toString());
      } catch (e) {}
    }

    function decorateExistingCrossDomainLinks() {
      const links = document.querySelectorAll('a[href]');
      Array.prototype.forEach.call(links, (linkEl) => {
        decorateCrossDomainLink(linkEl);
      });
    }
  
    function getTouchWithPrefix(prefix, touch) {
      const prefixed = {};
      const safePrefix = sanitizeString(prefix, 24);
      const safeTouch = sanitizeTouch(touch);
      Object.keys(safeTouch).forEach((key) => {
        prefixed[safePrefix + key] = safeTouch[key];
      });
      return prefixed;
    }
  
    const now = Date.now();
    const canonical = loadCanonicalAttribution();
    const incoming = buildIncomingTouch(now);
  
    canonical.source_origin = incoming.sourceOrigin || canonical.source_origin || 'shopify';
  
    if (incoming.isQualifying && !canonical.first_touch_at) {
      canonical.first_touch = sanitizeTouch(incoming.touch);
      canonical.first_touch_at = now;
    }
  
    if (
      incoming.isQualifying &&
      (!canonical.last_touch_at || shouldUpdateLastTouch(canonical.last_touch, incoming.touch))
    ) {
      canonical.last_touch = sanitizeTouch(incoming.touch);
      canonical.last_touch_at = now;
    }
  
    const normalizedCanonical = normalizeCanonical(canonical);
    persistCanonicalAttribution(normalizedCanonical);
  
    window.__sternAttribution = normalizedCanonical;
    window.__sternAttributionApi = {
      getCanonical: function () {
        return window.__sternAttribution || normalizeCanonical(null);
      },
      getFirstTouch: function () {
        return getFirstTouch(window.__sternAttribution);
      },
      getLastTouch: function () {
        return getLastTouch(window.__sternAttribution);
      },
      getMergedUtm: function () {
        return getMergedUtm(window.__sternAttribution);
      },
      getClickIds: function () {
        return getClickIds(window.__sternAttribution);
      },
      getDealSource: function (utmMerged, canonical) {
        return getDealSource(utmMerged, canonical || window.__sternAttribution);
      },
      getQueryDecoratorParams: function () {
        return getQueryDecoratorParams(window.__sternAttribution);
      },
      getFirstTouchWithPrefix: function (prefix) {
        return getTouchWithPrefix(prefix || 'first_', getFirstTouch(window.__sternAttribution));
      },
      getLastTouchWithPrefix: function (prefix) {
        return getTouchWithPrefix(prefix || 'last_', getLastTouch(window.__sternAttribution));
      }
    };

    function syncAttributionPersistenceWithConsent() {
      const current = window.__sternAttribution || normalizeCanonical(null);
      if (hasAnalyticsConsent()) {
        const persistent = normalizeCanonical(current);
        persistent.storage_mode = 'persistent';
        if (!persistent.visitor_id) persistent.visitor_id = createVisitorId();
        window.__sternAttribution = persistent;
        persistCanonicalAttribution(persistent);
        decorateExistingCrossDomainLinks();
        return;
      }

      clearPersistentAttribution();
      const memoryOnly = normalizeCanonical(current);
      memoryOnly.storage_mode = 'memory_only';
      memoryOnly.visitor_id = '';
      window.__sternAttribution = memoryOnly;
    }

    let attributionConsentSyncTimer = null;
    function scheduleAttributionConsentSync() {
      if (attributionConsentSyncTimer) window.clearTimeout(attributionConsentSyncTimer);
      attributionConsentSyncTimer = window.setTimeout(() => {
        attributionConsentSyncTimer = null;
        syncAttributionPersistenceWithConsent();
      }, 50);
    }

    document.addEventListener('cookieyes_consent_update', scheduleAttributionConsentSync);
    document.addEventListener('cookieyes-consent-updated', scheduleAttributionConsentSync);
    document.addEventListener('cookieyes-consent-init', scheduleAttributionConsentSync);
    document.addEventListener('cookieyes_banner_load', scheduleAttributionConsentSync);
    window.addEventListener('pageshow', scheduleAttributionConsentSync);
  
    // Backward compatible helpers used by other runtime modules.
    window.__sternGetUtmMerged = function () {
      return window.__sternAttributionApi.getMergedUtm();
    };
    window.__sternGetDealSource = function (utmMerged, canonical) {
      return window.__sternAttributionApi.getDealSource(utmMerged, canonical);
    };
  
    // Publish canonical attribution to the Shopify Web Pixel (which forwards it to GTM).
    if (window.__sternAttributionDataLayerPushed !== true) {
      window.__sternAttributionDataLayerPushed = true;
      const mergedUtm = window.__sternAttributionApi.getMergedUtm();
      const clickIds = window.__sternAttributionApi.getClickIds();
      var lastTouch = window.__sternAttributionApi.getLastTouch ? window.__sternAttributionApi.getLastTouch() : {};
      var sternAttributionPayload = {
        stern_attribution: window.__sternAttribution,
        deal_source: window.__sternAttributionApi.getDealSource(mergedUtm),
        referrer_hostname: lastTouch.referrer_hostname || '',
        landing_page: lastTouch.landing_page || '',
        utm_source: mergedUtm.utm_source || '',
        utm_medium: mergedUtm.utm_medium || '',
        utm_campaign: mergedUtm.utm_campaign || '',
        utm_content: mergedUtm.utm_content || '',
        utm_term: mergedUtm.utm_term || '',
        gclid: clickIds.gclid || '',
        dclid: clickIds.dclid || '',
        gbraid: clickIds.gbraid || '',
        wbraid: clickIds.wbraid || '',
        msclkid: clickIds.msclkid || '',
        fbclid: clickIds.fbclid || '',
        ttclid: clickIds.ttclid || '',
        twclid: clickIds.twclid || '',
        li_fat_id: clickIds.li_fat_id || '',
        pin_clickid: clickIds.pin_clickid || '',
        rdt_cid: clickIds.rdt_cid || '',
        canonical_source_origin: (window.__sternAttributionApi.getCanonical().source_origin) || ''
      };
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('stern_attribution_ready', sternAttributionPayload);
      }
    }

    const crossDomainDecorateHandler = function (event) {
      const anchorEl = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (anchorEl) decorateCrossDomainLink(anchorEl);
    };

    document.addEventListener('pointerdown', crossDomainDecorateHandler, true);
    document.addEventListener('focusin', crossDomainDecorateHandler, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', decorateExistingCrossDomainLinks);
    } else {
      decorateExistingCrossDomainLinks();
    }
  })();
  
// --- CFA Attribution Helpers (parity with OS1-Prod) ---
// These global functions are used by the CFA liquid template scripts
// and any future CFA form handlers in OS2.

const CFA_SUBMISSION_LOCK_MS = 30 * 1000;
window.__sternCfaSubmissionIds = window.__sternCfaSubmissionIds || {};
window.__sternFreshsalesSubmissionIds = window.__sternFreshsalesSubmissionIds || {};

function cfaSanitizeString(value, maxLength) {
    const limit = typeof maxLength === "number" ? maxLength : 512;
    if (value == null) return "";
    return String(value).trim().slice(0, limit);
}

function isCountrySelectionInvalid(value) {
    const COUNTRY_PLACEHOLDER_VALUE = "__select_country__";
    const normalized = cfaSanitizeString(value, 120).toLowerCase();
    return (
        normalized.length === 0 ||
        normalized === COUNTRY_PLACEHOLDER_VALUE ||
        normalized === "select country"
    );
}

function ensureCfaRequiredFields(formElement) {
    if (!formElement || !formElement.querySelector) return;
    const selectors = ["#first-name", "#last-name", "#email", "#zip-code", "#countrySelect"];
    selectors.forEach((selector) => {
        const field = formElement.querySelector(selector);
        if (!field || !field.setAttribute) return;
        field.setAttribute("required", "required");
        field.setAttribute("aria-required", "true");
    });
}

function cfaNormalizePhoneDigits(value, maxLength) {
    const limit = typeof maxLength === "number" ? maxLength : 15;
    if (value == null) return "";
    return String(value).replace(/\D+/g, "").slice(0, limit);
}

function cfaSyncPhoneInputValue(phoneField) {
    if (!phoneField || typeof phoneField.value === "undefined") return "";
    const normalized = cfaNormalizePhoneDigits(phoneField.value, 15);
    if (phoneField.value !== normalized) {
        phoneField.value = normalized;
    }
    return normalized;
}

function cfaReadCookieByName(name) {
    try {
        const pattern = "(?:^|;\\s*)" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)";
        const match = document.cookie.match(new RegExp(pattern));
        return match ? decodeURIComponent(match[1]) : "";
    } catch (error) {
        return "";
    }
}

function getAttributionApi() {
    return window.__sternAttributionApi && typeof window.__sternAttributionApi === "object"
        ? window.__sternAttributionApi
        : null;
}

function getCanonicalAttribution() {
    const api = getAttributionApi();
    if (api && typeof api.getCanonical === "function") {
        return api.getCanonical() || {};
    }
    return window.__sternAttribution || {};
}

function getMergedUtm() {
    const api = getAttributionApi();
    if (api && typeof api.getMergedUtm === "function") {
        return api.getMergedUtm() || {};
    }
    const params = new URLSearchParams(window.location.search);
    const fallback = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach((key) => {
        const value = cfaSanitizeString(params.get(key));
        if (value) fallback[key] = value;
    });
    return fallback;
}

function getClickIds() {
    const api = getAttributionApi();
    if (api && typeof api.getClickIds === "function") {
        return api.getClickIds() || {};
    }
    const params = new URLSearchParams(window.location.search);
    const fallback = {};
    [
        "gclid",
        "dclid",
        "gbraid",
        "wbraid",
        "msclkid",
        "fbclid",
        "ttclid",
        "twclid",
        "li_fat_id",
        "pin_clickid",
        "rdt_cid"
    ].forEach((key) => {
        const value = cfaSanitizeString(params.get(key));
        if (value) fallback[key] = value;
    });

    if (!fallback.rdt_cid) {
        const rdtCidCookie = cfaSanitizeString(cfaReadCookieByName("rdt_cid"), 128);
        if (rdtCidCookie) fallback.rdt_cid = rdtCidCookie;
    }
    return fallback;
}

function getTouchWithPrefix(prefix, touchData) {
    const touch = touchData && typeof touchData === "object" ? touchData : {};
    const result = {};
    const safePrefix = cfaSanitizeString(prefix, 24);
    Object.keys(touch).forEach((key) => {
        if (key === "landing_ts") {
            const parsedTs = Number(touch[key]);
            result[safePrefix + key] = Number.isFinite(parsedTs) && parsedTs > 0 ? String(Math.floor(parsedTs)) : "";
            return;
        }
        result[safePrefix + key] = cfaSanitizeString(touch[key], 768);
    });
    return result;
}

function getFormValue(formElement, selectors, maxLen) {
    const selectorList = Array.isArray(selectors) ? selectors : [selectors];
    const limit = typeof maxLen === "number" ? maxLen : 1024;
    for (let i = 0; i < selectorList.length; i++) {
        const selector = selectorList[i];
        if (!selector) continue;
        const field = (formElement && formElement.querySelector(selector)) || document.querySelector(selector);
        if (!field || typeof field.value === "undefined") continue;
        const value = cfaSanitizeString(field.value, limit);
        if (value) return value;
    }
    return "";
}

function readVariantFromProductUrl(productUrl) {
    try {
        if (!productUrl) return "";
        const parsed = new URL(productUrl, window.location.origin);
        return cfaSanitizeString(parsed.searchParams.get("variant"), 120);
    } catch (e) {
        return "";
    }
}

function buildProductUrlFromHandle(productHandle) {
    const handle = cfaSanitizeString(productHandle, 220);
    if (!handle) return "";
    return cfaSanitizeString(
        "https://shop.sternpinball.com/collections/games/products/" + encodeURIComponent(handle),
        1200
    );
}

function buildProductTitleFromHandle(productHandle) {
    const handle = cfaSanitizeString(productHandle, 220);
    if (!handle) return "";
    const text = handle
        .replace(/[-_]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    if (!text) return "";
    return cfaSanitizeString(text.replace(/\b\w/g, function (match) { return match.toUpperCase(); }), 240);
}

function buildCfaSubmissionId() {
    return "cfa_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
}

function buildSubmissionFingerprint(formElement) {
    if (!formElement) return "";
    const emailField = formElement.querySelector("#email");
    const zipCodeField = formElement.querySelector("#zip-code");
    const productField = formElement.querySelector("#contact-form-product-title");
    const variantField = formElement.querySelector("#variant");
    const mergedUtm = getMergedUtm();
    return [
        cfaSanitizeString(emailField && emailField.value, 120).toLowerCase(),
        cfaSanitizeString(zipCodeField && zipCodeField.value, 40).toLowerCase(),
        cfaSanitizeString(productField && productField.value, 180).toLowerCase(),
        cfaSanitizeString(variantField && variantField.value, 120).toLowerCase(),
        cfaSanitizeString(mergedUtm.utm_source, 120).toLowerCase(),
        cfaSanitizeString(mergedUtm.utm_medium, 120).toLowerCase(),
        cfaSanitizeString(mergedUtm.utm_campaign, 120).toLowerCase()
    ].join("|");
}

function setSubmitButtonState(buttonElement, isDisabled) {
    if (!buttonElement) return;
    buttonElement.disabled = isDisabled === true;
    if (buttonElement.tagName === "INPUT") {
        buttonElement.setAttribute("aria-disabled", isDisabled ? "true" : "false");
    }
}

function acquireSubmissionLock(formElement, submitButton) {
    if (!formElement) return { locked: false, reason: "missing-form" };
    const now = Date.now();
    const fingerprint = buildSubmissionFingerprint(formElement);
    const lastFingerprint = cfaSanitizeString(formElement.dataset.sternCfaFingerprint, 512);
    const lastSubmissionTs = Number(formElement.dataset.sternCfaLastSubmittedAt || 0);

    if (formElement.dataset.sternCfaSubmitting === "true") {
        return { locked: false, reason: "in-flight" };
    }
    if (
        fingerprint &&
        lastFingerprint &&
        fingerprint === lastFingerprint &&
        Number.isFinite(lastSubmissionTs) &&
        now - lastSubmissionTs < CFA_SUBMISSION_LOCK_MS
    ) {
        return { locked: false, reason: "duplicate" };
    }

    formElement.dataset.sternCfaSubmitting = "true";
    formElement.dataset.sternCfaFingerprint = fingerprint;
    formElement.dataset.sternCfaLastSubmittedAt = String(now);
    setSubmitButtonState(submitButton, true);
    return { locked: true, reason: "ok", fingerprint: fingerprint };
}

function releaseSubmissionLock(formElement, submitButton, keepRecentLock) {
    if (!formElement) return;
    formElement.dataset.sternCfaSubmitting = "false";
    if (keepRecentLock !== true) {
        formElement.dataset.sternCfaFingerprint = "";
        formElement.dataset.sternCfaLastSubmittedAt = "0";
    }
    setSubmitButtonState(submitButton, false);
}

function upsertHiddenField(formElement, fieldName, fieldValue) {
    if (!formElement || !fieldName) return;
    let field = formElement.querySelector('input[name="' + fieldName + '"]');
    if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = fieldName;
        formElement.appendChild(field);
    }
    field.value = fieldValue == null ? "" : String(fieldValue);
}

function applyContactFormMetaFields(formElement, meta) {
    if (!formElement) return;
    const safeMeta = meta || {};
    Object.keys(safeMeta).forEach((key) => {
        upsertHiddenField(formElement, "contact[" + key + "]", safeMeta[key] || "");
    });
}

function buildContactSubmitMeta(context) {
    const safeContext = context || {};
    const canonical = safeContext.canonicalAttribution || getCanonicalAttribution();
    const mergedUtm = safeContext.utmMerged || getMergedUtm();
    const clickIds = safeContext.clickIds || getClickIds();
    const firstTouch = canonical.first_touch || {};
    const lastTouch = canonical.last_touch || canonical.first_touch || {};
    const queryParams = new URLSearchParams(window.location.search);
    const utmSource = cfaSanitizeString(mergedUtm.utm_source || queryParams.get("utm_source") || "", 120);
    const utmMedium = cfaSanitizeString(mergedUtm.utm_medium || queryParams.get("utm_medium") || "", 120);
    const utmCampaign = cfaSanitizeString(mergedUtm.utm_campaign || queryParams.get("utm_campaign") || "", 160);
    const dealSource = cfaSanitizeString(
        safeContext.dealSource ||
        (window.__sternGetDealSource ? window.__sternGetDealSource(null, canonical) : "Shopify"),
        80
    );
    const inferredShopType = String(dealSource).toUpperCase() === "WP" ? "WP" : "Shopify";
    const submissionId = cfaSanitizeString(safeContext.submissionId || buildCfaSubmissionId(), 120);
    const isCesCampaign =
        cfaSanitizeString(queryParams.get("utm_source"), 64).toLowerCase() === "ces" &&
        cfaSanitizeString(queryParams.get("utm_medium"), 64).toLowerCase() === "event" &&
        cfaSanitizeString(queryParams.get("utm_campaign"), 64).toLowerCase() === "ces2026";
    const meta = {
        submission_id: submissionId,
        deal_source: dealSource,
        inquiry_source: cfaSanitizeString(safeContext.inquirySource || inferredShopType, 80),
        shop_type: cfaSanitizeString(safeContext.shopType || inferredShopType, 80),
        referrer_hostname: cfaSanitizeString(lastTouch.referrer_hostname, 128),
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: cfaSanitizeString(mergedUtm.utm_content || queryParams.get("utm_content"), 200),
        utm_term: cfaSanitizeString(mergedUtm.utm_term || queryParams.get("utm_term"), 200),
        ces_campaign: isCesCampaign ? "ces2026" : "",
        canonical_schema_version: String(Number(canonical.schema_version || 0) || 0),
        canonical_source_origin: cfaSanitizeString(canonical.source_origin, 40),
        first_touch_at: String(Number(canonical.first_touch_at || 0) || 0),
        last_touch_at: String(Number(canonical.last_touch_at || 0) || 0),
        session_start_at: String(Number(canonical.session_start_at || 0) || 0),
        session_last_at: String(Number(canonical.session_last_at || 0) || 0)
    };

    [
        "gclid",
        "dclid",
        "gbraid",
        "wbraid",
        "msclkid",
        "fbclid",
        "ttclid",
        "twclid",
        "li_fat_id",
        "pin_clickid",
        "rdt_cid"
    ].forEach((key) => {
        meta[key] = cfaSanitizeString(clickIds[key] || lastTouch[key], 256);
    });

    Object.assign(meta, getTouchWithPrefix("first_", firstTouch));
    Object.assign(meta, getTouchWithPrefix("last_", lastTouch));

    try {
        meta.attribution_json = JSON.stringify({
            schema_version: Number(canonical.schema_version || 0) || 0,
            source_origin: cfaSanitizeString(canonical.source_origin, 40),
            first_touch_at: Number(canonical.first_touch_at || 0) || 0,
            last_touch_at: Number(canonical.last_touch_at || 0) || 0,
            first_touch: firstTouch,
            last_touch: lastTouch,
            click_ids: clickIds
        });
    } catch (error) {
        meta.attribution_json = "";
    }

    return meta;
}

function validateField(inputValue, label, errorMessage, errorMessages) {
    const normalized = cfaSanitizeString(inputValue, 320);
    const isEmailRule = errorMessage.includes('valid');
    const isEmpty = normalized.length === 0;
    const isInvalidEmail = isEmailRule && !/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/.test(normalized);
    if (isEmpty || isInvalidEmail) {
        if (label !== null && label !== undefined) {
            label.style.color = "#D0021B";
        }
        errorMessages.push(errorMessage);
    } else {
        if (label !== null && label !== undefined) {
            label.style.color = "#000";
        }
    }
}

function validateCountryField(countryValue, label, errorMessages) {
    if (isCountrySelectionInvalid(countryValue)) {
        if (label !== null && label !== undefined) {
            label.style.color = "#D0021B";
        }
        errorMessages.push('Country is required.');
    } else if (label !== null && label !== undefined) {
        label.style.color = "#000";
    }
}

/**
 * CFA link + Reddit click id handling
 * - pulls product slug + active variant
 * - merges UTMs
 * - appends rdt_cid from URL or cookie
 * - pushes rdt_cid into dataLayer
 * - updates <a id="availability_link"> on load and just before click
 */
document.addEventListener("DOMContentLoaded", function () {
    function getAvailabilityAttributionParams() {
        if (
            window.__sternAttributionApi &&
            typeof window.__sternAttributionApi.getQueryDecoratorParams === "function"
        ) {
            return window.__sternAttributionApi.getQueryDecoratorParams() || {};
        }
        const fallback = getMergedUtm();
        const clickIds = getClickIds();
        return Object.assign({}, fallback, clickIds);
    }

    (function pushRdtToDataLayer() {
        const attributionParams = getAvailabilityAttributionParams();
        const rdtCid = attributionParams.rdt_cid || '';
        if (!rdtCid) return;
        if (window.__sternProductAvailabilityRdtPushed === true) {
            return;
        }
        window.__sternProductAvailabilityRdtPushed = true;
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('stern_reddit_click_id', { rdt_cid: rdtCid });
        }
    })();

    function updateAvailabilityLink() {
        const pathParts = window.location.pathname.split("/");
        const productSlug = pathParts[pathParts.length - 1];
        if (!productSlug) return;

        const activeVariant = document.querySelector(".type-product__value.active-value-product");
        const variantName = activeVariant ? activeVariant.textContent.trim() : "";
        const attributionParams = getAvailabilityAttributionParams();
        const availabilityUrl = new URL("https://shop.sternpinball.com/pages/contact-for-availability");
        availabilityUrl.searchParams.set("product", productSlug);
        if (variantName) {
            availabilityUrl.searchParams.set("variant", variantName);
        }
        Object.entries(attributionParams).forEach(([key, value]) => {
            if (!value) return;
            availabilityUrl.searchParams.set(key, String(value));
        });

        const linkElement = document.getElementById("availability_link");
        if (linkElement) {
            linkElement.setAttribute("href", availabilityUrl.toString());
        }
    }

    updateAvailabilityLink();
    setTimeout(updateAvailabilityLink, 500);
    setTimeout(updateAvailabilityLink, 1500);

    document.querySelectorAll(".type-product__value").forEach(element => {
        element.addEventListener("click", function () {
            updateAvailabilityLink();
        });
    });

    window.addEventListener('hashchange', updateAvailabilityLink);
    window.addEventListener('popstate', updateAvailabilityLink);

    // Ensure we patch the href right before navigation on click
    document.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        const link = e.target.closest('#availability_link');
        if (link) {
            updateAvailabilityLink();
        }
    }, true);
});
// --- CFA Product Modal Handler (vanilla JS, no jQuery) ---

function initCfaProductModal() {
    const COUNTRY_PLACEHOLDER_VALUE = "__select_country__";
    const btnContactForAvailability = document.querySelector(".btn-contact-for-availability");
    const contactFormModal = document.querySelector(".modal-contact-for-availability");
    const contactFormClose = document.querySelector(".contact-form-close");
    const contactFormBackground = document.querySelector(".contact-form-background");
    const bodyEl = document.body;

    // Country options are populated by the dedicated scripts-cfa runtime.

    // --- Modal open/close ---
    if (btnContactForAvailability) {
        btnContactForAvailability.addEventListener("click", function () {
            if (contactFormModal) {
                contactFormModal.classList.add("active-contact-form");
            }
            if (contactFormBackground) {
                contactFormBackground.classList.add("active-contact-form-background");
            }
            if (bodyEl) {
                bodyEl.classList.add("active-contact-form-body");
            }
        });
    }

    if (contactFormClose) {
        contactFormClose.addEventListener("click", function () {
            if (contactFormModal) {
                contactFormModal.classList.remove("active-contact-form");
            }
            if (contactFormBackground) {
                contactFormBackground.classList.remove("active-contact-form-background");
            }
            if (bodyEl) {
                bodyEl.classList.remove("active-contact-form-body");
            }
        });
    }

    if (contactFormBackground) {
        contactFormBackground.addEventListener("click", function () {
            if (contactFormModal) {
                contactFormModal.classList.remove("active-contact-form");
            }
            contactFormBackground.classList.remove("active-contact-form-background");
            if (bodyEl) {
                bodyEl.classList.remove("active-contact-form-body");
            }
        });
    }

    // --- Phone input normalization ---
    if (!window.__sternCfaPhoneInputBound) {
        window.__sternCfaPhoneInputBound = true;
        document.addEventListener("input", function (e) {
            if (e.target && e.target.matches && e.target.matches("#contact_form #phone, #contact-for-availability-modal #phone")) {
                cfaSyncPhoneInputValue(e.target);
            }
        });
        document.addEventListener("paste", function (e) {
            if (e.target && e.target.matches && e.target.matches("#contact_form #phone, #contact-for-availability-modal #phone")) {
                const field = e.target;
                setTimeout(function () { cfaSyncPhoneInputValue(field); }, 0);
            }
        });
    }

    // --- Form submission handler ---
    const form = document.getElementById("contact_form") ||
        (contactFormModal ? contactFormModal.querySelector('form[action*="/contact"]') : null);
    if (!form) return;

    const submitButton = form.querySelector('.contact-form-submit input[type="submit"]');

    form.addEventListener("submit", function (e) {
        // Allow native submit if flagged (fallback path)
        if (form.dataset && form.dataset.sternCfaAllowNative === "true") {
            form.dataset.sternCfaAllowNative = "false";
            return;
        }

        e.preventDefault();
        ensureCfaRequiredFields(form);

        const lockState = acquireSubmissionLock(form, submitButton);
        if (!lockState.locked) {
            if ((lockState.reason === "duplicate" || lockState.reason === "in-flight") &&
                window.alertNotification && typeof window.alertNotification.error === "function") {
                window.alertNotification.error("Your request is already being submitted.");
            }
            return;
        }

        // Read form values
        const firstName = cfaSanitizeString(getFormValue(form, ["#first-name"], 120), 120);
        const lastName = cfaSanitizeString(getFormValue(form, ["#last-name"], 120), 120);
        const emailInput = cfaSanitizeString(getFormValue(form, ["#email"], 180), 180);
        const postalCode = cfaSanitizeString(getFormValue(form, ["#zip-code"], 40), 40);
        const country = cfaSanitizeString(getFormValue(form, ["#countrySelect"], 120), 120);
        const phoneField = form.querySelector("#phone");
        const phoneDigits = cfaSyncPhoneInputValue(phoneField);

        // Validation
        const errorMessages = [];
        const labelFirstName = form.querySelector('.first-name-contact-form label');
        const labelEmail = form.querySelector('.email-contact-form label');
        const labelPostalCode = form.querySelector('.zip-code label');
        const labelCountry = form.querySelector('.select-contact-form label');

        validateField(firstName, labelFirstName, 'First name is required.', errorMessages);
        validateCountryField(country, labelCountry, errorMessages);
        validateField(postalCode, labelPostalCode, 'Postal code is required.', errorMessages);
        validateField(emailInput, labelEmail, 'Email is required and must be valid.', errorMessages);

        if (errorMessages.length > 0) {
            if (window.alertNotification && typeof window.alertNotification.error === "function") {
                window.alertNotification.error(errorMessages.join('\n'));
            }
            releaseSubmissionLock(form, submitButton, false);
            return;
        }

        if (isCountrySelectionInvalid(country)) {
            if (window.alertNotification && typeof window.alertNotification.error === "function") {
                window.alertNotification.error('Please select a country.');
            }
            if (labelCountry) labelCountry.style.color = "#D0021B";
            releaseSubmissionLock(form, submitButton, false);
            return;
        }

        // Build attribution
        const canonicalAttribution = getCanonicalAttribution();
        const utmMerged = getMergedUtm();
        const clickIds = getClickIds();
        const dealSource = (window.__sternGetDealSource ? window.__sternGetDealSource(null, canonicalAttribution) : 'Shopify');
        const inferredShopType = (String(dealSource).toUpperCase() === "WP") ? "WP" : "Shopify";
        const selectedShopType = getFormValue(form, ["#shopType"], 80) || inferredShopType;
        const submissionId = buildCfaSubmissionId();
        const contactSubmitMeta = buildContactSubmitMeta({
            submissionId: submissionId,
            canonicalAttribution: canonicalAttribution,
            utmMerged: utmMerged,
            clickIds: clickIds,
            dealSource: dealSource,
            inquirySource: selectedShopType,
            shopType: selectedShopType
        });

        applyContactFormMetaFields(form, contactSubmitMeta);

        // Build product data
        const pageParams = new URLSearchParams(window.location.search);
        const productHandleFromUrl = cfaSanitizeString(pageParams.get("product"), 220);
        const productUrlValue = getFormValue(form, ["#contact-form-product-url", "#product-url"], 1200) ||
            buildProductUrlFromHandle(productHandleFromUrl);
        const productPriceValue = getFormValue(form, ["#contact-form-product-pr", "#contact-form-product-price"], 120);
        const productTitleValue = getFormValue(form, ["#contact-form-product-title"], 240) ||
            cfaSanitizeString(pageParams.get("title"), 240) ||
            cfaSanitizeString(pageParams.get("product_title"), 240) ||
            buildProductTitleFromHandle(productHandleFromUrl);

        // Determine variant
        const selectEdition = document.querySelector(".select_editions .v_bg\\:red-400");
        const variantInput = form.querySelector("#variant");
        if (selectEdition && variantInput) {
            let selectEditionText = selectEdition.textContent.trim();
            if (selectEditionText === 'limited edition') {
                selectEditionText = 'LE';
            }
            variantInput.value = selectEditionText;
        } else if (variantInput && !variantInput.value) {
            variantInput.value = " ";
        }
        const variantValue = getFormValue(form, ["#variant"], 160) ||
            cfaSanitizeString(pageParams.get("variant"), 160) ||
            cfaSanitizeString(pageParams.get("product_variant"), 160) ||
            readVariantFromProductUrl(productUrlValue);

        // Build Freshsales payload
        const fsPayloadBase = {
            submission_id: submissionId,
            firstName: firstName,
            lastName: lastName,
            phone: phoneDigits,
            email: emailInput,
            zipCode: postalCode,
            zipcode: postalCode,
            source: getFormValue(form, ["#select"], 255),
            specification: getFormValue(form, ["#specification"], 255),
            message: getFormValue(form, ["#message"], 1024),
            productUrl: productUrlValue,
            productTitle: productTitleValue,
            productPrice: productPriceValue,
            InquirySource: selectedShopType,
            location: getFormValue(form, ["#location"], 255),
            locationAnswer: getFormValue(form, ["#locationAnswer"], 255),
            IPFamily: getFormValue(form, ["#ip_family"], 120),
            Version: getFormValue(form, ["#version"], 120),
            Variant: variantValue,
            ProductCategory: "Pinball Machine",
            country: country
        };
        Object.assign(fsPayloadBase, contactSubmitMeta);
        fsPayloadBase["product-title"] = productTitleValue;
        fsPayloadBase.product_title = productTitleValue;
        fsPayloadBase.variant = variantValue;
        fsPayloadBase["product-variant"] = variantValue;
        fsPayloadBase.product_variant = variantValue;
        fsPayloadBase["shop-type"] = selectedShopType;
        fsPayloadBase.shop_type = selectedShopType;
        fsPayloadBase.attribution = contactSubmitMeta;

        // Freshsales tracking function
        function trackFreshsalesForSubmission(extraMeta) {
            if (window.__sternFreshsalesSubmissionIds[submissionId]) {
                return Promise.resolve(true);
            }

            if (typeof window.__sternLoadFreshworks === "function") {
                window.__sternLoadFreshworks();
            }

            var fsPayload = Object.assign({}, fsPayloadBase, extraMeta || {});
            var identifyPayload = {
                "fs_contact": true,
                "First name": cfaSanitizeString(fsPayload.firstName, 120),
                "Email": cfaSanitizeString(fsPayload.email, 180),
                "Country": cfaSanitizeString(fsPayload.country, 120),
                "zipcode": cfaSanitizeString(fsPayload.zipcode || fsPayload.zipCode, 40),
                "Product Title": cfaSanitizeString(fsPayload["product-title"] || fsPayload.productTitle, 240),
                "Variant": cfaSanitizeString(fsPayload.variant || fsPayload.Variant, 160),
                "Product URL": cfaSanitizeString(fsPayload.productUrl, 1200),
                "Inquiry Source": cfaSanitizeString(fsPayload.InquirySource || fsPayload.shopType, 120),
                "product-title": cfaSanitizeString(fsPayload["product-title"] || fsPayload.productTitle, 240),
                "product_variant": cfaSanitizeString(fsPayload.product_variant || fsPayload.variant || fsPayload.Variant, 160),
                "referrer_hostname": cfaSanitizeString(fsPayload.referrer_hostname, 128),
                "deal_source": cfaSanitizeString(fsPayload.deal_source, 80),
                "utm_source": cfaSanitizeString(fsPayload.utm_source, 120),
                "utm_medium": cfaSanitizeString(fsPayload.utm_medium, 120),
                "utm_campaign": cfaSanitizeString(fsPayload.utm_campaign, 160),
                "IP Family": cfaSanitizeString(fsPayload.IPFamily, 120)
            };
            var sanitizedLastName = cfaSanitizeString(fsPayload.lastName, 120);
            if (sanitizedLastName) {
                identifyPayload["Last name"] = sanitizedLastName;
            }
            if (fsPayload.phone) {
                identifyPayload["Phone"] = cfaNormalizePhoneDigits(fsPayload.phone, 15);
            }
            var identifyPayloadSafe = {
                "fs_contact": true,
                "First name": cfaSanitizeString(fsPayload.firstName, 120),
                "Email": cfaSanitizeString(fsPayload.email, 180),
                "Country": cfaSanitizeString(fsPayload.country, 120),
                "zipcode": cfaSanitizeString(fsPayload.zipcode || fsPayload.zipCode, 40)
            };
            if (sanitizedLastName) {
                identifyPayloadSafe["Last name"] = sanitizedLastName;
            }
            var freshsalesErrors = [];

            function freshsalesErrorMessage(error) {
                if (!error) return "unknown";
                if (typeof error === "string") return error;
                if (error.message) return String(error.message);
                try {
                    return JSON.stringify(error);
                } catch (jsonError) {
                    return "unknown";
                }
            }

            function waitForFreshsalesIdentify() {
                return new Promise(function (resolve, reject) {
                    var startedAt = Date.now();
                    function checkReady() {
                        if (window.freshsales && typeof window.freshsales.identify === "function") {
                            resolve();
                            return;
                        }
                        if (Date.now() - startedAt >= 5000) {
                            reject(new Error("Freshsales lead API is unavailable."));
                            return;
                        }
                        setTimeout(checkReady, 100);
                    }
                    checkReady();
                });
            }

            function identifyLead(payload) {
                return new Promise(function (resolve, reject) {
                    var settled = false;
                    var timeoutId = setTimeout(function () {
                        if (settled) return;
                        settled = true;
                        reject(new Error("Freshsales lead submission timed out."));
                    }, 15000);

                    function succeed(response) {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timeoutId);
                        resolve(response);
                    }

                    function fail(error) {
                        if (settled) return;
                        settled = true;
                        clearTimeout(timeoutId);
                        reject(error instanceof Error ? error : new Error(freshsalesErrorMessage(error)));
                    }

                    try {
                        var identifyResult = window.freshsales.identify(
                            fsPayload.email,
                            payload,
                            succeed,
                            fail
                        );
                        if (identifyResult && typeof identifyResult.then === "function") {
                            identifyResult.then(succeed, fail);
                        }
                    } catch (identifyError) {
                        fail(identifyError);
                    }
                });
            }

            return waitForFreshsalesIdentify()
                .then(function () {
                    return identifyLead(identifyPayload)
                        .then(function (response) {
                            return {
                                response: response,
                                identifyEnrichedSent: true,
                                identifyFallbackUsed: false
                            };
                        })
                        .catch(function (identifyFullError) {
                            freshsalesErrors.push("identify_full:" + freshsalesErrorMessage(identifyFullError));
                            return identifyLead(identifyPayloadSafe).then(function (response) {
                                return {
                                    response: response,
                                    identifyEnrichedSent: false,
                                    identifyFallbackUsed: true
                                };
                            });
                        });
                })
                .then(function (identifyResult) {
                    var didAssociate = false;
                    var didTrackCustomEvent = false;
                    var didTrackMasEvent = false;
                    var canAssociate = window.FM && typeof window.FM.associateVisitor === "function";
                    var canTrackCustomEvent = window.FM && typeof window.FM.trackCustomEvent === "function";
                    var canTrackMasEvent = window.FM && typeof window.FM.trackMasEvent === "function";

                    if (canAssociate && fsPayload.email) {
                        try {
                            window.FM.associateVisitor(fsPayload.email);
                            didAssociate = true;
                        } catch (associateError) {
                            freshsalesErrors.push("associate:" + freshsalesErrorMessage(associateError));
                        }
                    }
                    if (canTrackCustomEvent) {
                        try {
                            window.FM.trackCustomEvent("Contact For Availability Form Submitted", fsPayload);
                            didTrackCustomEvent = true;
                        } catch (customEventError) {
                            freshsalesErrors.push("custom_event:" + freshsalesErrorMessage(customEventError));
                        }
                    }
                    if (canTrackMasEvent) {
                        try {
                            window.FM.trackMasEvent("web_form", true, {
                                digest: "contact_for_availability",
                                data: fsPayload
                            });
                            didTrackMasEvent = true;
                        } catch (masEventError) {
                            freshsalesErrors.push("mas_event:" + freshsalesErrorMessage(masEventError));
                        }
                    }

                    window.__sternFreshsalesSubmissionIds[submissionId] = true;
                    window.__sternCfaLastResponse = {
                        provider: "freshsales",
                        submission_id: submissionId,
                        response: identifyResult.response || null,
                        ts: Date.now()
                    };
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "freshsales_lead_submitted",
                        submission_id: submissionId,
                        identify_enriched_sent: identifyResult.identifyEnrichedSent,
                        identify_fallback_used: identifyResult.identifyFallbackUsed,
                        associated_visitor: didAssociate,
                        custom_event_sent: didTrackCustomEvent,
                        web_form_event_sent: didTrackMasEvent
                    });

                    if (freshsalesErrors.length > 0) {
                        console.warn("Freshsales lead was created with supplemental tracking warnings:", freshsalesErrors);
                    }
                    return true;
                })
                .catch(function (freshsalesError) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "freshsales_lead_failed",
                        submission_id: submissionId,
                        message: freshsalesErrorMessage(freshsalesError).slice(0, 500)
                    });
                    throw freshsalesError;
                });
        }

        // Submit directly to Freshsales. The confirmation is shown only after
        // Freshsales invokes its success callback for the lead identify request.
        trackFreshsalesForSubmission()
            .then(function () {
                if (!window.__sternCfaSubmissionIds[submissionId]) {
                    window.__sternCfaSubmissionIds[submissionId] = true;
                    window.dataLayer = window.dataLayer || [];

                    function queueGoogleAnalyticsContactEvent() {
                        window.dataLayer.push(arguments);
                    }

                    const googleContactEvent = {
                        send_to: 'G-17KJ15LV62',
                        event_id: submissionId,
                        submission_id: submissionId,
                        form_source: bodyEl && bodyEl.classList.contains('page-contact-for-availability')
                            ? 'cfa_page'
                            : 'product_modal',
                        method: 'form_submission',
                        deal_source: contactSubmitMeta.deal_source || '',
                        canonical_source_origin: contactSubmitMeta.canonical_source_origin || '',
                        referrer_hostname: contactSubmitMeta.referrer_hostname || '',
                        utm_source: contactSubmitMeta.utm_source || '',
                        utm_medium: contactSubmitMeta.utm_medium || '',
                        utm_campaign: contactSubmitMeta.utm_campaign || '',
                        utm_content: contactSubmitMeta.utm_content || '',
                        utm_term: contactSubmitMeta.utm_term || '',
                        first_touch_at: contactSubmitMeta.first_touch_at || '',
                        last_touch_at: contactSubmitMeta.last_touch_at || '',
                        page_hostname: window.location.hostname,
                        page_location: window.location.href,
                        page_referrer: document.referrer || '',
                        page_title: document.title,
                        page_path: window.location.pathname,
                        ces_campaign: contactSubmitMeta.ces_campaign || ''
                    };

                    queueGoogleAnalyticsContactEvent('event', 'contact_for_availability', googleContactEvent);
                    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
                        Shopify.analytics.publish('stern_contact_for_availability', {
                            submission_id: submissionId,
                            form_source: bodyEl && bodyEl.classList.contains('page-contact-for-availability')
                                ? 'cfa_page'
                                : 'product_modal',
                            method: 'form_submission',
                            deal_source: contactSubmitMeta.deal_source || '',
                            canonical_source_origin: contactSubmitMeta.canonical_source_origin || '',
                            referrer_hostname: contactSubmitMeta.referrer_hostname || '',
                            utm_source: contactSubmitMeta.utm_source || '',
                            utm_medium: contactSubmitMeta.utm_medium || '',
                            utm_campaign: contactSubmitMeta.utm_campaign || '',
                            utm_content: contactSubmitMeta.utm_content || '',
                            utm_term: contactSubmitMeta.utm_term || '',
                            gclid: contactSubmitMeta.gclid || '',
                            gbraid: contactSubmitMeta.gbraid || '',
                            wbraid: contactSubmitMeta.wbraid || '',
                            msclkid: contactSubmitMeta.msclkid || '',
                            fbclid: contactSubmitMeta.fbclid || '',
                            ttclid: contactSubmitMeta.ttclid || '',
                            twclid: contactSubmitMeta.twclid || '',
                            li_fat_id: contactSubmitMeta.li_fat_id || '',
                            pin_clickid: contactSubmitMeta.pin_clickid || '',
                            rdt_cid: contactSubmitMeta.rdt_cid || '',
                            first_touch_at: contactSubmitMeta.first_touch_at || '',
                            last_touch_at: contactSubmitMeta.last_touch_at || '',
                            page_path: window.location.pathname,
                            ces_campaign: contactSubmitMeta.ces_campaign || ''
                        });
                    }
                }

                if (contactFormBackground) {
                    contactFormBackground.classList.remove('active-contact-form-background');
                }
                if (bodyEl) bodyEl.classList.remove('active-contact-form-body');
                if (contactFormModal) contactFormModal.classList.remove('active-contact-form');

                if (window.alertNotification && typeof window.alertNotification.success === "function") {
                    window.alertNotification.success('Your request for availability has been sent.');
                }

                // Clear form fields
                setTimeout(function () {
                    var fields = form.querySelectorAll('input[type="text"], input[type="email"], input[type="number"], input[type="tel"], textarea, select');
                    fields.forEach(function (field) { field.value = ''; });
                }, 0);
                releaseSubmissionLock(form, submitButton, true);
            })
            .catch(function (error) {
                window.__sternCfaLastError = {
                    provider: "freshsales",
                    code: "freshsales_lead_failed",
                    message: error && error.message ? String(error.message) : "",
                    ts: Date.now()
                };

                console.error('There was a problem creating the Freshsales lead:', error);
                if (window.alertNotification && typeof window.alertNotification.error === "function") {
                    window.alertNotification.error('There was a problem sending your request. Please try again.');
                }
                releaseSubmissionLock(form, submitButton, false);
            });
    }, { capture: true });
}

// Initialize CFA modal when DOM is ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCfaProductModal);
} else {
    initCfaProductModal();
}
// --- END CFA Product Modal Handler ---

  // const typeProduct = document.querySelector('.type-product')
  //   if (typeProduct) {
  //         setTimeout(() => {
  //             const blobselect = document.querySelector('#product-variants')
  //            blobselect.style.display = 'none'
  
  //           }, "2000")
  //   }
  
  window.__sternScriptLoadPromises = window.__sternScriptLoadPromises || {};
  window.__sternLoadScriptOnce = window.__sternLoadScriptOnce || function loadScriptOnce(config) {
      const options = config || {};
      const scriptUrl = options.url;
      const scriptKey = options.key;
      const scriptAttr = options.scriptAttr;
  
      if (!scriptUrl || !scriptKey || !scriptAttr) {
          return Promise.resolve(false);
      }
  
      const promiseStore = window.__sternScriptLoadPromises;
      if (promiseStore[scriptKey]) {
          return promiseStore[scriptKey];
      }
  
      const statusAttr = scriptAttr + "-status";
      const scriptSelector = "script[" + scriptAttr + '="true"]';
  
      promiseStore[scriptKey] = new Promise((resolve) => {
          const existingScript = document.querySelector(scriptSelector);
          if (existingScript) {
              const existingStatus = existingScript.getAttribute(statusAttr);
              if (existingStatus === "loaded") {
                  resolve(true);
                  return;
              }
              if (existingStatus === "error") {
                  resolve(false);
                  return;
              }
              existingScript.addEventListener("load", () => resolve(true), { once: true });
              existingScript.addEventListener("error", () => resolve(false), { once: true });
              return;
          }
  
          const script = document.createElement("script");
          script.src = scriptUrl;
          script.async = true;
          script.setAttribute(scriptAttr, "true");
          script.setAttribute(statusAttr, "pending");
          script.onload = () => {
              script.setAttribute(statusAttr, "loaded");
              resolve(true);
          };
          script.onerror = () => {
              script.setAttribute(statusAttr, "error");
              resolve(false);
          };
          document.head.appendChild(script);
      });
  
      return promiseStore[scriptKey];
  };
  
  window.__sternAffirmSpacingTimers = window.__sternAffirmSpacingTimers || {};
  window.__sternApplyAffirmSpacingPatch = window.__sternApplyAffirmSpacingPatch || function applyAffirmSpacingPatch(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      const affirmContainer = scope.querySelector(".affirm-as-low-as") || document.querySelector(".affirm-as-low-as");
      const affirmPrice = scope.querySelector(".affirm-ala-price") || document.querySelector(".affirm-ala-price");
      if (!affirmContainer || !affirmPrice) {
          return false;
      }
      affirmContainer.style.margin = "40px 0 30px";
      return true;
  };
  
  window.__sternScheduleAffirmSpacingPatch = window.__sternScheduleAffirmSpacingPatch || function scheduleAffirmSpacingPatch(config) {
      const options = config || {};
      const rootNode = options.rootNode || document;
      const timerKey = options.timerKey || "default";
      const retryIntervalMs = typeof options.retryIntervalMs === "number" ? options.retryIntervalMs : 250;
      const maxAttempts = typeof options.maxAttempts === "number" ? options.maxAttempts : 20;
  
      const activeTimer = window.__sternAffirmSpacingTimers[timerKey];
      if (activeTimer) {
          window.clearInterval(activeTimer);
          delete window.__sternAffirmSpacingTimers[timerKey];
      }
  
      if (window.__sternApplyAffirmSpacingPatch(rootNode)) {
          return true;
      }
  
      let attempts = 0;
      const intervalId = window.setInterval(() => {
          attempts += 1;
          if (window.__sternApplyAffirmSpacingPatch(rootNode) || attempts >= maxAttempts) {
              window.clearInterval(intervalId);
              delete window.__sternAffirmSpacingTimers[timerKey];
          }
      }, retryIntervalMs);
      window.__sternAffirmSpacingTimers[timerKey] = intervalId;
      return false;
  };
  
  window.__sternMenuState = window.__sternMenuState || { activePanel: "" };
  
  function getMenuButtons() {
      return Array.from(document.querySelectorAll("[data-menu-target]"));
  }
  
  function getMenuPanels() {
      return Array.from(document.querySelectorAll("[data-menu-panel]"));
  }
  
  function syncMenuUi() {
      const activePanel = window.__sternMenuState.activePanel || "";
      const menuButtons = getMenuButtons();
      const menuPanels = getMenuPanels();
  
      menuButtons.forEach((button) => {
          const targetPanel = button.getAttribute("data-menu-target") || "";
          const isExpanded = !!activePanel && targetPanel === activePanel;
          button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
          button.classList.toggle("is:active", isExpanded);
      });
  
      menuPanels.forEach((panel) => {
          const panelName = panel.getAttribute("data-menu-panel") || "";
          const shouldShow = !!activePanel && panelName === activePanel;
          panel.hidden = !shouldShow;
          panel.setAttribute("aria-hidden", shouldShow ? "false" : "true");
          if (shouldShow) {
              panel.removeAttribute("inert");
              panel.style.pointerEvents = "";
          } else {
              panel.setAttribute("inert", "");
              panel.style.pointerEvents = "none";
          }
      });
  }
  
  function setActiveMenuPanel(panelName) {
      window.__sternMenuState.activePanel = panelName || "";
      syncMenuUi();
  }
  
  function toggleMenuPanel(panelName) {
      if (!panelName) {
          setActiveMenuPanel("");
          return;
      }
      const currentPanel = window.__sternMenuState.activePanel || "";
      setActiveMenuPanel(currentPanel === panelName ? "" : panelName);
  }
  
  function initMenuController() {
      if (window.__sternMenuControllerBound === true) {
          syncMenuUi();
          return;
      }
  
      window.__sternMenuControllerBound = true;
      setActiveMenuPanel("");
  
      document.addEventListener("click", (event) => {
          const toggleButton = event.target && event.target.closest
              ? event.target.closest("[data-menu-target]")
              : null;
          if (toggleButton) {
              event.preventDefault();
              const targetPanel = toggleButton.getAttribute("data-menu-target");
              toggleMenuPanel(targetPanel);
              return;
          }
  
          const closeButton = event.target && event.target.closest
              ? event.target.closest("[data-menu-close]")
              : null;
          if (closeButton) {
              event.preventDefault();
              setActiveMenuPanel("");
              return;
          }
  
          if (!window.__sternMenuState.activePanel) {
              return;
          }
  
          const clickInsidePanel = event.target && event.target.closest
              ? event.target.closest("[data-menu-panel]")
              : null;
          const clickInsideToggle = event.target && event.target.closest
              ? event.target.closest("[data-menu-target]")
              : null;
          if (!clickInsidePanel && !clickInsideToggle) {
              setActiveMenuPanel("");
          }
      });
  
      document.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && window.__sternMenuState.activePanel) {
              setActiveMenuPanel("");
          }
      });
  
      document.addEventListener("shopify:section:load", () => {
          syncMenuUi();
      });
  }
  
  function initSelectGoToController() {
      if (window.__sternSelectGoToBound === true) {
          return;
      }
  
      window.__sternSelectGoToBound = true;
      document.addEventListener("change", (event) => {
          const selectNode = event.target && event.target.closest
              ? event.target.closest("select[data-select-go-to]")
              : null;
          if (!selectNode) {
              return;
          }
  
          const nextUrl = typeof selectNode.value === "string" ? selectNode.value.trim() : "";
          if (!nextUrl || nextUrl === window.location.href) {
              return;
          }
          window.location.href = nextUrl;
      });
  }
  
  function safeQuerySelector(selector) {
      if (!selector || typeof selector !== "string") {
          return null;
      }
      try {
          return document.querySelector(selector);
      } catch (error) {
          return null;
      }
  }
  
  function smoothScrollToNode(targetNode, triggerNode) {
      if (!(targetNode instanceof Element)) {
          return;
      }
  
      if (window.blobScroll && typeof window.blobScroll.scroll === "function") {
          window.blobScroll.scroll(triggerNode || targetNode);
          return;
      }
  
      if (typeof targetNode.scrollIntoView === "function") {
          targetNode.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
          });
      }
  }
  
  function initHashAnchorScrollController() {
      if (window.__sternHashAnchorScrollBound === true) {
          return;
      }
  
      window.__sternHashAnchorScrollBound = true;
      document.addEventListener("click", (event) => {
          const anchorNode = event.target && event.target.closest
              ? event.target.closest('a[href^="#"]:not([data-scroll-ignore])')
              : null;
          if (!(anchorNode instanceof HTMLAnchorElement)) {
              return;
          }
  
          const hashValue = anchorNode.getAttribute("href") || "";
          if (hashValue.length < 2) {
              return;
          }
  
          const targetNode = safeQuerySelector(hashValue);
          if (!targetNode) {
              return;
          }

          event.preventDefault();
          if (anchorNode.classList.contains("skip-link")) {
              if (window.history && typeof window.history.replaceState === "function") {
                  window.history.replaceState(null, "", hashValue);
              } else {
                  window.location.hash = hashValue;
              }
              if (typeof targetNode.focus === "function") {
                  targetNode.focus({ preventScroll: true });
              }
          }
          smoothScrollToNode(targetNode, anchorNode);
      });
  }
  
  function scrollToInitialHashTarget() {
      if (window.__sternInitialHashScrolled === true) {
          return;
      }
      window.__sternInitialHashScrolled = true;
  
      const hashValue = window.location && typeof window.location.hash === "string"
          ? window.location.hash
          : "";
      if (!hashValue || hashValue === "#") {
          return;
      }
  
      const targetNode = safeQuerySelector(hashValue);
      if (!targetNode) {
          return;
      }
  
      window.setTimeout(() => {
          smoothScrollToNode(targetNode, targetNode);
      }, 0);
  }
  
  function applyWysiwygImageCleanup(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const imageNodes = scope.querySelectorAll(".t_wysiwyg img:not([data-wpcleaned])");
      imageNodes.forEach((imageNode) => {
          imageNode.setAttribute("data-wpcleaned", "1");
  
          if (
              imageNode.classList.contains("wp-smiley") ||
              imageNode.classList.contains("emoji") ||
              imageNode.classList.contains("alignleft") ||
              imageNode.classList.contains("alignright") ||
              imageNode.classList.contains("aligncenter")
          ) {
              return;
          }
  
          const parentNode = imageNode.parentNode;
          if (!(parentNode instanceof Element)) {
              return;
          }
  
          if (
              parentNode.tagName === "PICTURE" ||
              parentNode.classList.contains("alignleft") ||
              parentNode.classList.contains("alignright") ||
              parentNode.classList.contains("aligncenter")
          ) {
              return;
          }
  
          parentNode.classList.add("has-img");
      });
  }
  
  function isManagedEmbedIframe(iframeNode) {
      if (!(iframeNode instanceof HTMLIFrameElement)) {
          return false;
      }
      if (
          iframeNode.closest(".shopify-preview-bar, [id*='preview-bar'], [id*='PreviewBar'], [data-shopify-preview-bar]")
      ) {
          return false;
      }
      const parentNode = iframeNode.parentNode;
      if (parentNode === document.body || parentNode === document.documentElement) {
          return false;
      }
      return !!iframeNode.closest(".t_wysiwyg, .rte, .custom__item-inner--html");
  }

  function applyWysiwygEmbedCleanup(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const iframeNodes = scope.querySelectorAll("iframe:not([data-wpcleaned])");
      iframeNodes.forEach((iframeNode) => {
          if (!isManagedEmbedIframe(iframeNode)) {
              return;
          }
          iframeNode.setAttribute("data-wpcleaned", "1");
          const parentNode = iframeNode.parentNode;
          if (!(parentNode instanceof Element)) {
              return;
          }
          parentNode.classList.add("has-embed");
      });
  }
  
  function applyResponsiveIframeSizing(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const iframeNodes = scope.querySelectorAll("iframe:not([data-fitvidsed])");
      iframeNodes.forEach((iframeNode) => {
          if (!isManagedEmbedIframe(iframeNode)) {
              return;
          }
          iframeNode.setAttribute("data-fitvidsed", "1");
          if (iframeNode.classList.contains("instagram-media")) {
              return;
          }

          const parentNode = iframeNode.parentNode;
          if (!(parentNode instanceof HTMLElement)) {
              return;
          }
          if (parentNode === document.body || parentNode === document.documentElement) {
              return;
          }
  
          const attrWidth = parseInt(iframeNode.getAttribute("width"), 10);
          const attrHeight = parseInt(iframeNode.getAttribute("height"), 10);
          const rect = iframeNode.getBoundingClientRect();
          const width = attrWidth || rect.width || iframeNode.offsetWidth;
          const height = attrHeight || rect.height || iframeNode.offsetHeight;
          if (!width || !height) {
              return;
          }
  
          const paddingPercent = (100 * (height / width)) + "%";
          iframeNode.style.position = "absolute";
          iframeNode.style.top = "0";
          iframeNode.style.right = "0";
          iframeNode.style.bottom = "0";
          iframeNode.style.left = "0";
          iframeNode.style.width = "100%";
          iframeNode.style.height = "100%";
          parentNode.style.position = "relative";
          parentNode.style.paddingTop = paddingPercent;
      });
  }
  
  // Legacy Vue-core lifecycle behavior migrated to delegated vanilla hooks.
  function applyLegacyContentEnhancements(rootNode) {
      applyWysiwygImageCleanup(rootNode);
      applyWysiwygEmbedCleanup(rootNode);
      applyResponsiveIframeSizing(rootNode);
  }
  
  function getInteractionsScriptUrl() {
      if (
          window.__sternTheme &&
          typeof window.__sternTheme.interactionsUrl === "string" &&
          window.__sternTheme.interactionsUrl.length
      ) {
          return window.__sternTheme.interactionsUrl;
      }
      return "/assets/scripts-interactions.js";
  }
  
  function rootNeedsInteractions(rootNode) {
      const scope = rootNode && rootNode.querySelector ? rootNode : document;
      return !!scope.querySelector(".header-with-timer__time, .ui-accordion-header, .wrapper_accordion");
  }
  
  function loadInteractionsScriptIfNeeded(rootNode) {
      if (!rootNeedsInteractions(rootNode)) {
          return Promise.resolve(false);
      }
  
      if (window.__sternInteractions && typeof window.__sternInteractions.onSectionLoad === "function") {
          window.__sternInteractions.onSectionLoad(rootNode);
          return Promise.resolve(true);
      }
  
      const interactionsScriptUrl = getInteractionsScriptUrl();
      if (!interactionsScriptUrl) {
          return Promise.resolve(false);
      }
  
      return window.__sternLoadScriptOnce({
          key: "stern-interactions",
          url: interactionsScriptUrl,
          scriptAttr: "data-stern-interactions"
      }).then((loaded) => {
          if (loaded && window.__sternInteractions && typeof window.__sternInteractions.onSectionLoad === "function") {
              window.__sternInteractions.onSectionLoad(rootNode);
          }
          return loaded;
      });
  }

  const heroSliderInstances = new WeakMap();

  function getThemeI18nText(path, fallbackValue) {
      const root = window.__sternTheme && window.__sternTheme.i18n ? window.__sternTheme.i18n : {};
      const segments = String(path || "").split(".");
      let current = root;
      for (let i = 0; i < segments.length; i += 1) {
          const key = segments[i];
          if (!current || typeof current !== "object" || !(key in current)) {
              return fallbackValue;
          }
          current = current[key];
      }
      return typeof current === "string" && current ? current : fallbackValue;
  }

  function applyHeroSliderAccessibility(sliderNode) {
      if (!(sliderNode instanceof HTMLElement)) {
          return;
      }

      sliderNode.setAttribute("role", "region");
      sliderNode.setAttribute("aria-roledescription", "carousel");
      if (!sliderNode.getAttribute("aria-label")) {
          sliderNode.setAttribute("aria-label", "Hero slider");
      }

      const sliderRoot = sliderNode.closest(".tns-outer") || sliderNode.parentElement;
      if (!sliderRoot) {
          return;
      }

      const nextLabel = getThemeI18nText("accessibility.nextSlide", "Next slide");
      const prevLabel = getThemeI18nText("accessibility.previousSlide", "Previous slide");
      const controls = sliderRoot.querySelectorAll(".tns-controls [data-controls], .tns-controls button");
      controls.forEach((control) => {
          if (!(control instanceof HTMLElement)) {
              return;
          }
          const controlName = control.getAttribute("data-controls") || "";
          const label = controlName === "prev" ? prevLabel : nextLabel;
          control.setAttribute("aria-label", label);
          control.setAttribute("title", label);
      });
  }

  function initHeroSlider(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const sliderNodes = scope.querySelectorAll(".js_slider");
      if (!sliderNodes.length || typeof window.tns !== "function") {
          return;
      }

      sliderNodes.forEach((sliderNode) => {
          if (heroSliderInstances.has(sliderNode)) {
              return;
          }

          try {
              const sliderInstance = window.tns({
                  container: sliderNode,
                  autoplayTimeout: 5000,
                  autoHeight: false,
                  speed: 1000,
                  items: 1,
                  slideBy: 1,
                  controls: true,
                  controlsText: ["", ""],
                  autoplay: true,
                  mode: "gallery"
              });

              heroSliderInstances.set(sliderNode, sliderInstance || true);
              window.setTimeout(() => applyHeroSliderAccessibility(sliderNode), 0);
          } catch (error) {
              // Keep storefront functional even if tiny-slider fails to initialize.
          }
      });
  }

  function destroyHeroSlider(rootNode) {
      const scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
      const sliderNodes = scope.querySelectorAll(".js_slider");
      if (!sliderNodes.length) {
          return;
      }

      sliderNodes.forEach((sliderNode) => {
          const sliderInstance = heroSliderInstances.get(sliderNode);
          if (!sliderInstance) {
              return;
          }

          if (sliderInstance && typeof sliderInstance.destroy === "function") {
              sliderInstance.destroy();
          }
          heroSliderInstances.delete(sliderNode);
      });
  }
  
  if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
          initMenuController();
          initSelectGoToController();
          initHashAnchorScrollController();
          scrollToInitialHashTarget();
          applyLegacyContentEnhancements(document);
          loadInteractionsScriptIfNeeded(document);
          initHeroSlider(document);
      });
  } else {
      initMenuController();
      initSelectGoToController();
      initHashAnchorScrollController();
      scrollToInitialHashTarget();
      applyLegacyContentEnhancements(document);
      loadInteractionsScriptIfNeeded(document);
      initHeroSlider(document);
  }
  
  function onThemeSectionLoad(event) {
      const rootNode = event && event.target ? event.target : document;
      if (window.__sternCfa && typeof window.__sternCfa.onSectionLoad === 'function') {
          window.__sternCfa.onSectionLoad(rootNode);
      }
      applyLegacyContentEnhancements(rootNode);
      loadInteractionsScriptIfNeeded(rootNode);
      initHeroSlider(rootNode);
      document.dispatchEvent(new CustomEvent("stern:section-reloaded"));
  }
  
  function onThemeSectionUnload(event) {
      const rootNode = event && event.target ? event.target : null;
      if (!rootNode || !rootNode.querySelectorAll) {
          return;
      }

      destroyHeroSlider(rootNode);

      if (window.__sternInteractions && typeof window.__sternInteractions.onSectionUnload === 'function') {
          window.__sternInteractions.onSectionUnload(rootNode);
      }
  
      if (window.__sternCfa && typeof window.__sternCfa.onSectionUnload === 'function') {
          window.__sternCfa.onSectionUnload(rootNode);
      }
  }
  
  function onThemeBlockSelect(event) {
      const targetNode = event && event.target ? event.target : null;
      if (!targetNode || !targetNode.closest) {
          return;
      }
  
      const selectedHeroSlide = targetNode.closest('.js_slide');
      if (selectedHeroSlide) {
          selectedHeroSlide.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
          });
      }
  }
  
  document.addEventListener('shopify:section:load', onThemeSectionLoad);
  document.addEventListener('shopify:section:unload', onThemeSectionUnload);
  document.addEventListener('shopify:block:select', onThemeBlockSelect);
}

// [module] src/runtime/entries/scripts.mjs

registerLegacyScriptsRuntime();

})();
